import _ from '@/utils/lodash-optimized'
import { createSelector } from 'reselect'

const getCurrentClient = redux =>
    redux?.globalVars?.params?.clientName

const getModalPatientFormClient = redux =>
    redux?.patientForm?.clientName

const EMPTY_CLIENTS_ARRAY = []

export const getGlobalVarsClients = redux =>
    redux?.globalVars?.clients || EMPTY_CLIENTS_ARRAY

// export getUserAvailableClients = redux

export const getDivisions = createSelector(
  [ getCurrentClient, getModalPatientFormClient, getGlobalVarsClients ],
  (client, modalClient, clients) =>
    _.chain(clients)
      .find(c => c.clientName === client || c.clientName === modalClient)
      .get('divisions', [])
        .map(d => d?.name)
      .value()
)
